export default __webpack_public_path__ + "static/media/wn-6.41c0e6ac.png";